import React, { useEffect, useState } from 'react';
import { PageButtonIcon, PageButtonNumber, Container, SectionProjeto, ThisCard, ScrollOS } from './styles';
import * as XLSX from 'xlsx';

import IconProjeto from '~/assets/icones/IconProjeto.svg';
import IconExcel from "~/assets/icones/IconExcel.svg";
import IconExcelB from "~/assets/icones/IconExcelB.svg";

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [pagAtiva, setPagAtiva] = useState(0);
  const [geraExcel, setGeraExcel] = useState(false);
  const sizePage = 10;

  function addPagination(pag, maxPag) {
    // Cria o html do item da paginação
    const identificaAtivo = (paginaAtual, paginaAdd, points) => {
      if (!points) {
        return <PageButtonNumber
          type="button"
          onClick={() => setPagAtiva(paginaAdd - 1)}
          key={paginaAdd}
          ativo={paginaAtual === paginaAdd ? 1 : undefined}
          numberdigits={paginaAdd}
        >
          <span />
          <p>{paginaAdd}</p>
        </PageButtonNumber>;
      } else {
        return <PageButtonNumber type="button">...</PageButtonNumber>;
      }
    };

    let itens = [];
    if (pag > 0) {
      if (maxPag === 0) {
        // html += identificaAtivo(0, 1);
      } else if (pag <= 3) {
        if (maxPag > 9) {
          itens.push(identificaAtivo(pag, 1));
          itens.push(identificaAtivo(pag, 2));
          itens.push(identificaAtivo(pag, 3));
          itens.push(identificaAtivo(pag, 4));
          itens.push(identificaAtivo(0, 0, true));
          itens.push(identificaAtivo(pag, maxPag - 3));
          itens.push(identificaAtivo(pag, maxPag - 2));
          itens.push(identificaAtivo(pag, maxPag - 1));
          itens.push(identificaAtivo(pag, maxPag));
        } else {
          for (var count = 1; count <= maxPag; count++) {
            itens.push(identificaAtivo(pag, count));
          }
        }
      } else if (pag <= maxPag - 3) {
        itens.push(identificaAtivo(pag, 1));
        itens.push(identificaAtivo(0, 0, true));
        itens.push(identificaAtivo(pag, pag - 2));
        itens.push(identificaAtivo(pag, pag - 1));
        itens.push(identificaAtivo(pag, pag));
        itens.push(identificaAtivo(pag, pag + 1));
        itens.push(identificaAtivo(pag, pag + 2));
        itens.push(identificaAtivo(0, 0, true));
        itens.push(identificaAtivo(pag, maxPag));
      } else if (pag > maxPag - 3) {
        if (maxPag > 9) {
          itens.push(identificaAtivo(pag, 1));
          itens.push(identificaAtivo(pag, 2));
          itens.push(identificaAtivo(pag, 3));
          itens.push(identificaAtivo(pag, 4));
          itens.push(identificaAtivo(0, 0, true));
          itens.push(identificaAtivo(pag, maxPag - 3));
          itens.push(identificaAtivo(pag, maxPag - 2));
          itens.push(identificaAtivo(pag, maxPag - 1));
          itens.push(identificaAtivo(pag, maxPag));
        } else {
          for (let count = 1; count <= maxPag; count++) {
            itens.push(identificaAtivo(pag, count));
          }
        }
      } else {
        itens.push(identificaAtivo(0, 1));
      }
    }
    return itens;
  }

  useEffect(() => {
    if (data && data?.length) {
      let dados = [[]];
      let page = 0;
      let count = 0;

      for (const item of data[0]?.projetos) {
        dados[page].push(item);

        if (sizePage == (count + 1)) {
          dados.push([]);

          count = 0;
          page++;
        }

        count++;
      }

      setPagAtiva(0);
      setDataPage(dados);
    }
  }, [data]);

  useEffect(() => {
    if (data && data?.length) {
      let dados = [];

      for (const item of data[0]?.projetos) {
        dados.push({
          "Id Projeto": item?.id,
          "Titulo": item?.titulo,
          "Cliente": item?.cliente?.nomeFantasia,
          "Coordenador": item?.coordenador?.nome,
          "Previsão de Inicio": ((new Date(item?.previsaoInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0],
          "Previsão de Entrega": ((new Date(item?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0],
          "Etapa": item?.etapa?.titulo,
          "Horas Total": item?.horaTotal,
          "Horas Saldo": item?.horaSaldo,
          "Horas Usado": item?.horaUsada,
          "%": ((item?.horaUsada * 100) / item?.horaTotal).toFixed(2),
        });
      }

      const worksheet = XLSX.utils.json_to_sheet(dados);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Projetos");
      XLSX.writeFile(workbook, "Projetos" + (new Date().toLocaleString('pt-BR', { timeZone: 'UTC' })) + ".xlsx");
    }
  }, [geraExcel]);

  return (
    <Container>
      <div className="content-oc">
        <SectionProjeto height={((dataPage[pagAtiva]?.length * 6) + 11) + "em"}>
          <div className="header">
            <div className="div-icone">
              <img src={IconProjeto} alt={"IconProjeto"} />
              <h4 className="title">Projetos</h4>
            </div>
            <div className="div-right">
              <button className="btn-excel" onClick={() => setGeraExcel(true)}>
                <img src={localStorage.getItem("tema") == "E" ? IconExcel : IconExcelB} alt="Icone de Excel" />
              </button>
              <div className="pagination">
                <PageButtonIcon
                  type="button"
                  onClick={() => pagAtiva > 0 ? setPagAtiva(pagAtiva - 1) : setPagAtiva(pagAtiva)}
                  className="material-icons"
                >
                  navigate_before
                </PageButtonIcon>
                <div className="pag-number">
                  {addPagination(pagAtiva + 1, dataPage?.length)}
                </div>
                <PageButtonIcon
                  type="button"
                  onClick={() => { pagAtiva < (dataPage?.length - 1) ? setPagAtiva(pagAtiva + 1) : setPagAtiva(pagAtiva) }}
                  className=" material-icons"
                >
                  navigate_next
                </PageButtonIcon>
              </div>
            </div>
          </div>
          <ScrollOS>
            <div className="display-oc">
              <ThisCard
                className="card-header"
                {...{ linhaAtiva, setLinhaAtiva }}
                ativo={false}
              >
                <div className="row">
                  <div className="col w1">
                    <div className="card-cod">
                      <p className="cod">Id</p>
                    </div>
                  </div>
                  <div className="col w3">
                    <p>Título</p>
                  </div>
                  <div className="col w2">
                    <p>Cliente</p>
                  </div>
                  <div className="col w2">
                    <p>Coordenador</p>
                  </div>
                  <div className="col w1">
                    <p>Prev Inicio</p>
                  </div>
                  <div className="col w1">
                    <p>Prev Final</p>
                  </div>
                  <div className="col w2">
                    <p>Etapa</p>
                  </div>
                  <div className="col w1 center">
                    <p>Total</p>
                  </div>
                  <div className="col w2 center">
                    <p>Saldo Lib</p>
                  </div>
                  <div className="col w1 center">
                    <p>Usado</p>
                  </div>
                  <div className="col w1 center">
                    <p>%</p>
                  </div>
                  <div className="col w2 center">
                    <p>Atrasos</p>
                  </div>
                </div>
              </ThisCard>
              {dataPage[pagAtiva]?.map((thisProjeto, i) => (
                <ThisCard
                  className={
                    linhaAtiva === thisProjeto?.id ? 'card-item ativo' : 'card-item'
                  }
                  {...{ data: thisProjeto, linhaAtiva, setLinhaAtiva }}
                  key={thisProjeto?.id || i}
                  id={thisProjeto?.id || i}
                  index={i}
                  ativo={linhaAtiva === thisProjeto?.id ? true : false}
                >
                  <div className="row">
                    <div className="col w1">
                      <div className="card-cod">
                        <p className="cod">#{thisProjeto?.id}</p>
                      </div>
                    </div>
                    <div className="col w3">
                      <p>{thisProjeto?.titulo}</p>
                    </div>
                    <div className="col w2">
                      <p>{thisProjeto?.cliente?.nomeFantasia}</p>
                    </div>
                    <div className="col w2">
                      <p>{thisProjeto?.coordenador?.nome}</p>
                    </div>
                    <div className="col w1">
                      <p>{((new Date(thisProjeto?.previsaoInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                    </div>
                    <div className="col w1">
                      <p>{((new Date(thisProjeto?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                    </div>
                    <div className="col w2">
                      <p>{thisProjeto?.etapa?.titulo}</p>
                    </div>
                    <div className="col w1 center">
                      <p>{thisProjeto?.horaTotal}h</p>
                    </div>
                    <div className="col w2 center">
                      <p>{thisProjeto?.horaSaldo}h</p>
                    </div>
                    <div className="col w1 center">
                      <p>{thisProjeto?.horaUsada}h</p>
                    </div>
                    <div className="col w1 center">
                      <p>{((thisProjeto?.horaUsada * 100) / thisProjeto?.horaTotal).toFixed(2)}%</p>
                    </div>
                    <div className="col w2 center">
                      <p>{thisProjeto?.diasAtrasos}</p>
                    </div>
                  </div>
                </ThisCard>
              ))}
            </div>
          </ScrollOS>
        </SectionProjeto>
      </div>
    </Container>
  );
}

export default CustomBodyContent;
